<template>
     <Exception type="404" />
</template>
<script>
    export default {
        
    }
</script>